import { Form } from "react-bootstrap";
import { LocalStorageKeys } from "../constants/storageKeys";
import React, { useEffect, useState, useContext } from "react";
import Services from "../services/services";
import Button from "../components/buttons/Button";
import { ModalContext } from "../context/contextProvider";
import { ThemeColorsEnum } from "../constants/enums";
import { Buffer } from "buffer";
import  FormFileInputAndDisplay  from "./forms/FormFileInputAndDisplay";

const getExtension = (fileName) => {
  return fileName.split(".").pop();
}

const AlertBox = ({ alert, preview, ...otherProps }) => {
  const [fileContent, setFileContent] = useState(null);
  const [fileUrl, setFileUrl] = useState();
  const filePathId = alert?.filePathId ?? false;
  const [isLoading, setIsLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [numPages, setNumPages] = useState();


  const { showModal } = useContext(ModalContext);

  const handleCheckboxChange = () => {
    if (preview) return;

    Services.localStorage.setProperty(LocalStorageKeys.hideAlertId, alert?.id);
  };

  useEffect(() => {
    const loadFile = async () => {
      if (filePathId) {
        setIsLoading(true);
        try {
          const metaData = await Services.api.fileStorage.getFileMetadata(filePathId);
          if (!metaData.ok) {
            console.log(metaData);
            return Services.utility.toast("Error: ", metaData.problem);
          }
          const fileData = await Services.api.fileStorage.getFile(filePathId);

          if (fileData.ok) {
            const extension = getExtension(metaData?.data?.displayName);
            setFileContent({ fileData, metaData, extension });
          }
          else {
            console.error("got bad response from server: ", fileData);
            return Services.utility.toast("Problem retrieving file");
          }
        } catch (error) {
          console.error("Error loading file:", error);
        } finally {
          setIsLoading(false);
        }
      }
    };

    loadFile();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleShowPdfClicked = () => {
    showModal(
      `${fileContent?.metaData?.data?.displayName}`,
      <div>
        <object
          data={fileUrl}
          type='application/pdf'
          width='750px'
          height='1200px'
          aria-label='PDF Document'
        />
        <p>
          Page {pageNumber} of {numPages}
        </p>
      </div>,
      [
        {
          color: ThemeColorsEnum.quaternary,
          title: "Close",
        },
      ],
      null,
      "lg",
    );

    Services.api.users.trackFeature({
      usageType: "Alert PDF Viewed"
    });
  };

  const RenderOptionalFile = () => {

    if (!fileContent) {
      console.log("RenderFileContent called with no content")
      return (<p> No file found </p>);
    }
    const { fileData, metaData, extension } = fileContent;
    if (filePathId) {
      //Stream file
      if (extension === "png" || extension === "jpg") {
        const base64Img = URL.createObjectURL(fileData?.data);
        return (
          <div >
            <img style={{ maxWidth: '95%', margin: '20' }} src={base64Img} />
          </div>
        );
      }
      else if (extension === "pdf") {

        //TODO: memo or cache this
        const reader = new FileReader();
        reader.readAsDataURL(fileData?.data);
        reader.onloadend = function() {
          setFileUrl(`data:application/pdf;base64,${reader.result.substring(reader.result.indexOf(',') + 1)}`);
        };

        return (
          <div>
            <Button title="View Pdf" onClick={handleShowPdfClicked} />
          </div>
        )


      }
    }

    return (<p> No file found </p>);

  }
  return (
    <span style={{ color: "white" }}>
      <span style={{ fontWeight: "bold" }}>{alert?.title}</span>
      <br />
      {alert?.notes}
      <br />
      <i>
        <Form.Check
          label="Don't show this again"
          onChange={handleCheckboxChange}
        />
      </i>
      {filePathId && (
        isLoading ? <div> Loading... </div> : <RenderOptionalFile fileContent={fileContent} filePathId={filePathId} />
      )}
          </span>
  );
};

export default AlertBox;
